import { useCallback, useEffect, useMemo, useState } from "react";
import { genericGet } from "services/services.general";
import { getFormattedOptions } from "utility/helpers";

const useProvinces = (regionId = null) => {
  const [provinces, setProvinces] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    genericGet({
      url: "/province",
      params: regionId != null ? { regionId } : null,
      callback: (data) => {
        setProvinces(data);
        setIsLoading(false);
      },
    });
  }, [regionId]);

  const options = useMemo(() => {
    return getFormattedOptions("name", provinces);
  }, [provinces]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: provinces,
    isLoading,
    refetch,
    options,
  };
};

export default useProvinces;
